import { ApiSetSupplierAccess, getSupplierAccessOverviewQueryKey } from '@kaiizen/kai-pro-api';
import { useCachedQuery } from '@kaiizen/react-persistent-cache';
import { useMemo, useRef } from 'react';
import { useKaiProApiClient } from '../useKaiProApiClient';

export const useSupplierAccess = () => {
  const kaiProApiClient = useKaiProApiClient();
  const query = useCachedQuery(getSupplierAccessOverviewQueryKey(), () => kaiProApiClient.getSupplierAccessOverview(), {
    enabled: !!kaiProApiClient.token,
  });

  const isFetchingRef = useRef(query.isFetching);
  isFetchingRef.current = query.isFetching;

  const mutators = useMemo(() => {
    // refetch() joins a fetch already in flight, which may have started before this write; fetch once more so the write shows.
    const refetchAfterWrite = async () => {
      const joinsInFlightFetch = isFetchingRef.current;
      await query.refetch();
      if (joinsInFlightFetch) await query.refetch();
    };
    return {
      save: async (payload: ApiSetSupplierAccess) => {
        await kaiProApiClient.setSupplierAccess(payload);
        await refetchAfterWrite();
      },
      remove: async (supplierAccessId: string) => {
        await kaiProApiClient.deleteSupplierAccess(supplierAccessId);
        await refetchAfterWrite();
      },
    };
  }, [kaiProApiClient, query.refetch]);

  return { ...query, suppliers: query.data?.suppliers ?? [], records: query.data?.records ?? [], ...mutators };
};
